import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { TranslateFunction } from 'react-localize-redux';

import { Snackbar } from '../../../../atoms/Snackbar/Snackbar';
import { Typography } from '../../../../atoms/Typography/Typography';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0),
    width: '100%',

    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  snackbar: { marginTop: theme.spacing(1.75) },
  text: { color: theme.palette.grey[600], textDecoration: 'line-through' },
}));

type Props = {
  name: string;
  translate: TranslateFunction;
};

export function UnavailableBasketItem(props: Props): JSX.Element {
  const { name, translate } = props;
  const classes = useStyles();
  const rootStyles = clsx('fd-unavailable-basketitem', classes.root);

  return (
    <div className={rootStyles}>
      <Typography className={classes.text}>{name}</Typography>
      <Snackbar
        className={classes.snackbar}
        message={translate('Reorder_Unavailable') as string}
        size="xs"
        type="secondary"
        variant="warning"
      />
    </div>
  );
}
